/**
 * A profile is "complete" when an associate can actually reach the person:
 * name + a phone + a city. This gates the curriculum page.
 */
const REQUIRED = [
  { key: 'firstName', label: 'Nome' },
  { key: 'lastName', label: 'Sobrenome' },
  { key: 'cellphone', label: 'Celular' },
  { key: 'city', label: 'Cidade' },
]

const filled = (v) => typeof v === 'string' ? v.trim().length > 0 : v != null && v !== ''

/** Labels of the required fields still missing, in display order. */
export const getMissingProfileFields = (profile) => {
  if (!profile) return REQUIRED.map((f) => f.label)
  return REQUIRED.filter((f) => !filled(profile[f.key])).map((f) => f.label)
}

export const isProfileComplete = (profile) => getMissingProfileFields(profile).length === 0
